import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequisicaoExternaService } from '@services/requisicaoexterna.service';
import { UtilService } from '@services/util.service';

@Component({
  selector: 'app-piscinao_detalhe',
  templateUrl: './piscinao_detalhe.component.html',
  styleUrls: ['./piscinao_detalhe.component.css'],
})

export class PiscinaoDetalheComponent implements AfterViewInit {
  utilService: UtilService;
  id;
  constructor(route: ActivatedRoute, private requisicaoExternaService: RequisicaoExternaService, @Inject(DOCUMENT) public document: Document) {
    this.id = route.snapshot.paramMap.get('id');
  }

  ngAfterViewInit(): void {
    this.functionAtualizarRelatorioTomus();
  }

  functionAtualizarRelatorioTomus = () => {
    var parametro = "piscinaoDetalhe_" + this.id;

    this.requisicaoExternaService.ObterResultado(parametro).subscribe(resultado => {
      const urlObject = URL.createObjectURL(new Blob([resultado.resultadoRequisicao], {
        type: 'text/html'
      }));

      var referenciaElementoTestado = this.document.getElementById("iframePiscinaoDetalhe") as HTMLIFrameElement;
      referenciaElementoTestado.src = urlObject;
    });
  }
}
